import React, { Component } from 'react';
import { connect } from 'react-redux'

class Text extends Component {
    shouldComponentUpdate(nextProps, nextState){
        return this.props.langPack !== nextProps.langPack;
    }
    render(){
        if(this.props.html){
            return this.renderHTML();
        }else{
            return this.renderPureText();
        }
    }
    renderHTML(){
        return <span dangerouslySetInnerHTML={{__html:this.props.langPack[this.props.id]}}></span>
    }
    renderPureText() {
        return (
            <React.Fragment>
                {this.props.langPack[this.props.id] || null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    // const lang = state.app.lang;
    // console.log(state)
    return {
        langPack : state.app.langPack
    }
}

export default connect(mapStateToProps)(Text);



// WEBPACK FOOTER //
// ./src/common/Text/index.js